import React, { useEffect } from "react";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import { connect } from 'react-redux'
import axios from 'axios'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField';
import { fade, makeStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
// import Cards from 'react-credit-cards';
// import { createForm } from 'final-form'
// import Styles from './Styles'
// import Card from './Card'
// import {
//   formatCreditCardNumber,
//   formatCVC,
//   formatExpirationDate
// } from './cardUtils'


const useStyles = makeStyles(theme => ({
  root: {
    width: '80%',
    margin: '20px'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  grid: {
    margin: '10px',
    padding: '10px',
    width: '95%'
  },
  gridParent: {
    margin: '10px',
    padding: '10px',
    width: '95%',
    border: '3px solid #aaa',
    borderRadius: '20px'
  },
  gridItem: {
    padding: '5px'
  },
  textSaveLineBreaks: {
    whiteSpace: 'pre-line'
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paymentProfiles: {
    border: '1px solid',
    // marginRight: '5px',
    // padding: '5px'
  },
  bigText: {
    fontSize: '1.5em',
    color: '#333',
    textAlign: 'center'
  }
}));

function SimpleModal(props) {
  // console.log('Rqquired LIne Items Props: ', props)
  const classes = useStyles();
  const [item, setItem] = React.useState({});

  React.useEffect(() => {
    if (props.editing && props.defaultLineItem && props.defaultLineItem.text) {
      // console.log('EDITING this: ', props)
      setItem(props.defaultLineItem)
    } else {
      setItem({})
    }
  }, [props])

  const divStyle = {
    // margin: '40px',
    // border: '5px solid pink',
    display: 'inline'
  };

  const handleClose = () => {
    // console.log(useRef.current)
    props.closeModal()
  }

  const handleSubmit = () => {
  // console.log('Submit', item)
    props.saveItem(item)
  }

  const handleUpdateItem= (e) => {
    setItem({...item, text: e.target.value})
  }

  let helperText = ''
  if (props.service.requiredInputs && props.service.requiredInputs.length) {
    helperText = <>
        <label>You May Use The Following Variables:</label>
          { props.service.requiredInputs.map((item, index) => {
            return (
              <li key={index}>{`{${item.name}} - ${item.description}`}</li>
            )
            })
          }
      </>

    // console.log('Helper Text: ', helperText)
  }
  
  return (
    <div style={ divStyle }>
      <Dialog
        maxWidth='md'
        // fullScreen={fullScreen}
        open={props.open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Please Enter Required Line Item Info Below</DialogTitle>
        <DialogContent> 
          <DialogContentText>
              This line item will automatically be added to any proposal that includes this service.
          </DialogContentText>
          <TextField
            id="LineItem"
            label="New Line Item"
            type="text"
            fullWidth
            value={item.text}
            // ref={inputRef}
            className={classes.textField}
            onChange={handleUpdateItem}
            variant="outlined"
            // onChange={ e => setState({...state, serviceCode: e.target.value}) }
            // onChange={ e => handleServiceChange(state.workorder, 'scheduledDate', e.target.value, state.serviceIndex) }
            InputLabelProps={{
              shrink: true,
            }}
            helperText={helperText}
          />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    url: state.url,
    user: state.user,
    notification: state.notification
  }
}

export default connect(mapStateToProps)(SimpleModal)